class ProductGrid extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
  }

  connectedCallback() {
    this.addCarouselParameters();

    window.addEventListener("shopify:section:load", () => {
      this.addCarouselParameters();
    });
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      pagination: {
        el: document.querySelector(`.product-grid__carousel-dots`),
        clickable: true
      },
      slidesPerView: "auto",
      spaceBetween: 12,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      roundLenghts: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      breakpoints: {
        767: {
          enabled: false,
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0
        }
      },
      on: {
        init: swiper => {
          swiper.el.style.overflow = "visible";
          if (window.innerWidth > 767) {
            swiper.el.querySelector(".swiper-wrapper").style.display = "grid";
            swiper.el.querySelector(".swiper-wrapper").style.gridTemplateColumns = "repeat(auto-fit, minmax(18.75rem, 1fr))";
            swiper.el.querySelector(".swiper-wrapper").style.gap = "2rem";
          }
        },
        resize: swiper => {
          if (window.innerWidth > 767) {
            swiper.el.querySelector(".swiper-wrapper").style.display = "grid";
            swiper.el.querySelector(".swiper-wrapper").style.gridTemplateColumns = "repeat(auto-fit, minmax(18.75rem, 1fr))";
            swiper.el.querySelector(".swiper-wrapper").style.gap = "2rem";
          } else {
            swiper.el.querySelector(".swiper-wrapper").style.display = "flex";
            swiper.el.querySelector(".swiper-wrapper").style.removeProperty("grid-template-columns");
            swiper.el.querySelector(".swiper-wrapper").style.removeProperty("gap");
          }
        }
      }
    });
    this.carousel.initialize();
  }
}

if (!customElements.get("product-grid")) customElements.define("product-grid", ProductGrid);
